module.exports = __webpack_public_path__ + "static/img/ve.1f85fe92.svg";